import zh from 'view-design/dist/locale/zh-CN'
import en from 'view-design/dist/locale/en-US'
import ja from 'view-design/dist/locale/ja-JP'
import ko from 'view-design/dist/locale/ko-KR'
import tw from 'view-design/dist/locale/zh-TW'

const iviewLangs = {
  zh,
  en,
  ja,
  ko,
  tw
}

export default iviewLangs
